import React, { FC } from 'react';
import { RequestStatus } from '../types';
import {
  StatusPill,
  StatusText,
  SuccessPill,
  InverseStatusText,
} from '../UserRequestsStyles';
import { UserRequestStatusIcon } from '../../icons/UserRequestStatusIcon';

const StatusBadge: FC<{ status: RequestStatus }> = ({ status }) => {
  return (
    <StatusPill>
      <UserRequestStatusIcon status={status} />
      <StatusText variant="body2">{status.toUpperCase()}</StatusText>
    </StatusPill>
  );
};

const NewStatusBadge = () => (
  <SuccessPill>
    <InverseStatusText variant="body2">NEW</InverseStatusText>
  </SuccessPill>
);

const StatusRequest: FC<{ status: RequestStatus }> = ({ status }) => {
  return status === 'New' ? (
    <NewStatusBadge />
  ) : (
    <StatusBadge status={status} />
  );
};

export default StatusRequest;
